import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

export default function initInitGsap() {
    document.addEventListener('DOMContentLoaded', () => {

        // Hero title word-by-word fade in
        const heroTitles = document.querySelectorAll('.hero-title');
        heroTitles.forEach((title) => {
            const text = title.textContent.trim();
            title.innerHTML = text.split(' ').map(
                (word) => `<span class="hero-word" style="display:inline-block;opacity:0">${word}</span>`
            ).join(' ');

            const words = title.querySelectorAll('.hero-word');
            gsap.to(words, {
                opacity: 1,
                y: 0,
                duration: 2.2,
                ease: 'power2.out',
                stagger: .1,
                delay: .5,
            });
        });

        // Hero subtitle fade in (non-home pages)
        if (!document.body.classList.contains('home')) {
            const heroSubtitle = document.querySelector('.hero-subtitle');
            if (heroSubtitle) {
                gsap.from(heroSubtitle, {
                    opacity: 0,
                    y: 20,
                    duration: 1.5,
                    ease: 'power2.out',
                    delay: 1,
                });
            }
        }

        // Fade up elements animation
        const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
        fadeUpElements.forEach((element, index) => {
            gsap.from(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top 80%',
                    toggleActions: 'play none none reset',
                },
                duration: 1,
                opacity: 0,
                y: 50,
                ease: 'power2.out',
                stagger: 0.15,
                delay: index * 0.15
            });
        });

        // Navbar background fade in on scroll
        const navbar = document.querySelector('#wrapper-navbar .navbar');
        const hero = document.querySelector('#wrapper-hero');
        if (navbar && hero) {
            gsap.fromTo(navbar,
                { backgroundColor: 'rgba(27, 106, 119, 0)' },
                {
                    backgroundColor: 'rgba(27, 106, 119, 1)',
                    ease: 'none',
                    scrollTrigger: {
                        trigger: hero,
                        start: 'top top',
                        end: 'bottom top',
                        scrub: true,
                    }
                }
            );
        }

        // Banner image parallax
        const bannerImages = document.querySelectorAll('.banner-image');
        bannerImages.forEach((wrapper) => {
            const img = wrapper.querySelector('img');
            if (!img) return;

            gsap.fromTo(img,
                { yPercent: -15 },
                {
                    yPercent: 15,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    }
                }
            );
        });

        // Image over left/right fade in with stagger
        const imgOverSections = document.querySelectorAll('.wp-block-columns:has(.img-over-left, .img-over-right)');
        imgOverSections.forEach((section) => {
            const images = section.querySelectorAll('.img-over-left, .img-over-right');
            gsap.from(images, {
                scrollTrigger: {
                    trigger: section,
                    start: 'top 75%',
                    toggleActions: 'play none none reset',
                },
                duration: 1,
                opacity: 0,
                y: 40,
                ease: 'power2.out',
                stagger: 0.3,
            });
        });

        // Full banner image parallax
        const fullBanners = document.querySelectorAll('.img-full-banner');
        fullBanners.forEach((wrapper) => {
            const img = wrapper.querySelector('img');
            if (!img) return;

            gsap.fromTo(img,
                { yPercent: -15 },
                {
                    yPercent: 15,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: wrapper,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true,
                    }
                }
            );
        });

    });
}
